import script from "./default.vue?vue&type=script&setup=true&lang=js"
export * from "./default.vue?vue&type=script&setup=true&lang=js"

import "./default.vue?vue&type=style&index=0&id=626d4dae&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-626d4dae"]])

export default __exports__